















































































































































// import ContentTitle from '@/components/ContentTitle.vue';
import { createClient } from 'newt-client-js';
import NoticeModal from '@/components/NoticeModal.vue';
import { UserMixin, SlackMixin } from '@/Mixin';

export default {
  name: 'PaidServices',
  components: { /*ContentTitle,*/ NoticeModal },
  mixins: [UserMixin, SlackMixin],
  data() {
    return {
      services: [],
      selected: [],
    };
  },
  async mounted() {
    const client = createClient({
      spaceUid: 'filmination',
      token: 'pM63Y4w9ZboBgFoC8RaG3Ka2uWBJV8DRJxkc9G8-3jo',
      apiType: 'cdn',
    });
    const result = await client.getContents({
      appUid: 'services',
      modelUid: 'service',
      query: {
        order: ['_sys.createdAt'],
      },
    });
    console.log(result);
    this.services = result.items.reverse();
  },
  methods: {
    toggleSelection(index: number) {
      if (this.selected.includes(index)) {
        const at = this.selected.indexOf(index);
        this.selected.splice(at, 1);
      } else {
        this.selected.push(index);
      }
    },
    async sendSelection() {
      const selectedServices = this.selected
        .map((item) => {
          return this.services[item].title;
        })
        .join(', ');
      const url = new URL(window.location.href);
      const message = `${(this as any).loginUserName}様(${
        (this as any).loginEmail
      })から有償サービスの依頼が来ました。必要としているサービスは：${selectedServices}になります。`;
      await (this as any).sendSlackMessage(message, '_paid-services');
      //reset
      this.$modal.show('sentRequestModal');
      this.selected = [];
    },
  },
};
